<template>
  <div class="container page">
    <van-nav-bar :title="$t('kefu.title')" class="custom-navbar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="service-container">
      <div class="service-card">
        <div class="service-header">
          <div class="service-avatar">
            <img class="service-avatar-img" src="img/mine/kefu.png" alt="客服">
          </div>
          <div class="service-info">
            <div class="service-name">
              {{this.$store.getters.getBaseInfo.name !==undefined ?this.$store.getters.getBaseInfo.name:$t('kefu.defaultName')}}
            </div>
            <div class="service-status">
              <span class="status-dot"></span>
              <span class="status-text">{{$t('')}}</span>
            </div>
          </div>
          <div class="service-action" @click="toServicePage()">
            <div class="contact-btn">
              <van-icon name="chat-o" class="btn-icon" />
              <span class="btn-text">{{$t('kefu.lianxi')}}</span>
            </div>
          </div>
        </div>
        
        <div class="service-content">
          <div class="service-desc">
            <van-icon name="info" class="desc-icon" />
            <span class="desc-text">{{$t('kefu.content')}}</span>
          </div>
        </div>

        <div class="service-features">
          <div class="feature-item" @click="contactWhatsApp()">
            <div class="feature-icon whatsapp">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.418"/>
              </svg>
            </div>
            <div class="feature-text">WhatsApp</div>
          </div>
          <div class="feature-item" @click="contactTelegram()">
            <div class="feature-icon telegram">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.374 0 0 5.373 0 12s5.374 12 12 12 12-5.373 12-12S18.626 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.14.14-.26.26-.534.26l.213-3.053 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.136-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/>
              </svg>
            </div>
            <div class="feature-text">Telegram</div>
          </div>
          <div class="feature-item" @click="contactFacebook()">
            <div class="feature-icon facebook">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </div>
            <div class="feature-text">Facebook</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    back() {
      return window.history.back();
    },
    toServicePage() {
      this.$router.push("ServicePage");
    },
    contactWhatsApp() {
      // WhatsApp联系逻辑
      window.open('https://wa.me/你的WhatsApp号码', '_blank');
    },
    contactTelegram() {
      // Telegram联系逻辑
      window.open('https://t.me/你的Telegram用户名', '_blank');
    },
    contactFacebook() {
      // Facebook联系逻辑
      window.open('https://facebook.com/你的Facebook页面', '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
}

.custom-navbar {
  background: transparent !important;
  
  ::v-deep .van-nav-bar__content {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border-radius: 0 0 20px 20px;
  }
  
  ::v-deep .van-nav-bar__title {
    color: #fff;
    font-weight: 600;
  }
}

.service-container {
  padding: 20px;
  margin-top: 20px;
}

.service-card {
  background: #fff;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
  animation: cardEntrance 0.6s ease-out;
}

@keyframes cardEntrance {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.service-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.service-avatar {
  position: relative;
  margin-right: 20px;
}

.service-avatar-img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 3px solid #667eea;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.service-info {
  flex: 1;
}

.service-name {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
}

.service-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #52c41a;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
  }
}

.status-text {
  font-size: 24px;
  color: #666;
}

.service-action {
  margin-left: auto;
}

.contact-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #3498db, #8e44ad);
  border-radius: 25px;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(15, 52, 96, 0.4);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(15, 52, 96, 0.6);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.btn-icon {
  font-size: 24px;
}

.btn-text {
  font-size: 26px;
}

.service-content {
  background: #f8f9ff;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 25px;
  border-left: 4px solid #667eea;
}

.service-desc {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.desc-icon {
  color: #667eea;
  font-size: 24px;
  margin-top: 2px;
  flex-shrink: 0;
}

.desc-text {
  font-size: 26px;
  color: #666;
  line-height: 1.4;
}

.service-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 15px;
  border-radius: 15px;
  background: #f8f9ff;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(15, 52, 96, 0.2);
  }
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  
  svg {
    width: 30px;
    height: 30px;
  }
  
  &.whatsapp {
    background: #25D366;
    color: #fff;
  }
  
  &.telegram {
    background: #55aaff;
    color: #fff;
  }
  
  &.facebook {
    background: #00aaff;
    color: #fff;
  }
}

.feature-text {
  font-size: 22px;
  color: #333;
  font-weight: 600;
  transition: all 0.3s ease;
}

// 响应式设计
@media (max-width: 768px) {
  .service-container {
    padding: 15px;
  }
  
  .service-card {
    padding: 20px;
  }
  
  .service-name {
    font-size: 24px;
  }
  
  .service-avatar-img {
    width: 70px;
    height: 70px;
  }
  
  .contact-btn {
    padding: 10px 20px;
  }
  
  .btn-text {
    font-size: 20px;
  }
  
  .desc-text {
    font-size: 20px;
  }
  
  .service-features {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .feature-item {
    flex-direction: row;
    text-align: left;
    gap: 15px;
    padding: 15px;
  }
  
  .feature-icon {
    margin-bottom: 0;
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    
    svg {
      width: 25px;
      height: 25px;
    }
  }
  
  .feature-text {
    font-size: 18px;
  }
}
</style>